module.exports = __webpack_public_path__ + "img/pdf.2cfbc956.png";